import actions from "./actions";
import mutations from "./mutations";

const state = {
  list: [],
  statusFilter: null,
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
